import {Grid, GridProps} from "@mantine/core";
import {InvoiceEntity} from "@ots-frontend/ots-data";
import {TransportLineItemDataTable} from "../../data-table/TransportLineItemDataTable/TransportLineItemDataTable"

export type InvoiceLineItemViewProps = Omit<GridProps, 'children'> & {
  invoice: InvoiceEntity
}

export const InvoiceLineItemView = (props: InvoiceLineItemViewProps) => {
  const {
    invoice,
    ...rest
  } = props

  return (
    <Grid {...rest}>
      <Grid.Col span={12}>
        <TransportLineItemDataTable
          withBorder
          records={invoice.tlis}
        />
      </Grid.Col>
    </Grid>
  )
}
